import { useEffect } from "react";
import styles from "./style.module.css";

/**
 * Full-page frame shared by the review, preview and parent pages: the design tokens,
 * the centred 1184px column and the vertical rhythm between sections. The header is
 * full-bleed, so it is passed separately from the column's children.
 *
 * Everything on an SPR page renders inside it (footer, logo strip, skeleton, error state),
 * because the `--spr-*` tokens exist only on `.page`.
 *
 * @param {React.ReactNode} [hero] - full-width content above the column (the header)
 * @param {React.ReactNode} children - the sections
 * @param {React.ReactNode} [footer] - full-width content below the column (sticky bar, logos)
 * @param {string} [className] - extra class on the column
 * @param {boolean} [reveal] - the report itself: the header's content and then each section fade
 *   in one after another (the loading design's option E). Other frames do not animate.
 */
const SprPageFrame = ({ hero, children, footer, className = "", reveal = false }) => {
  // The page scrollbar belongs to <html>, outside this component: tag it while an SPR page is
  // mounted so it takes the sections' scrollbar colours, and untag it on the way out.
  useEffect(() => {
    const root = document.documentElement;
    root.classList.add(styles.pageScrollbar);
    return () => root.classList.remove(styles.pageScrollbar);
  }, []);

  return (
    <div className={`${styles.page} ${reveal ? styles.reveal : ""}`}>
      {hero}
      <main className={`${styles.column} ${className}`}>{children}</main>
      {footer}
    </div>
  );
};

export default SprPageFrame;
